import { Box, Section } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { useTimeTrackingFeatureAvailabilityForCurrentCompany } from 'modules/attendance/lib/useTimeTrackingFeatureAvailability'
import type AttendanceSetting from 'modules/attendance/store/models/AttendanceSetting'

import AutofillTimesheet from './AutofillTimesheet'
import EditTimesheetAuthorization from './EditTimesheetAuthorization'
import MissingClockIn from './MissingClockIn'
import MissingClockOut from './MissingClockOut'
import OvertimeAuthorization from './OvertimeAuthorization'

interface PolicyProps {
  attendanceSetting: AttendanceSetting
}

const Timesheet = ({ attendanceSetting }: PolicyProps) => {
  const overtimeRequestsEnabled = useTimeTrackingFeatureAvailabilityForCurrentCompany(
    'time_tracking_overtime_requests'
  )
  const hasAutofillTimesheet = useTimeTrackingFeatureAvailabilityForCurrentCompany(
    'time_tracking_autofill_timesheet'
  )
  const editTimesheetAuthorizationEnabled = useTimeTrackingFeatureAvailabilityForCurrentCompany(
    'time_tracking_edit_timesheet_authorization'
  )
  const inconsistenciesEnabled = useTimeTrackingFeatureAvailabilityForCurrentCompany(
    'time_tracking_time_alerts'
  )

  return (
    <Section
      illustration="lock-user"
      title={i18n.t('time_tracking.settings.timesheet_approvals.title')}
      description={i18n.t('time_tracking.settings.timesheet_approvals.description')}
      extra={{ 'data-intercom-target': 'attendance-timesheet-section' }}
    >
      <Box gap="s24">
        {overtimeRequestsEnabled && <OvertimeAuthorization attendanceSetting={attendanceSetting} />}
        {editTimesheetAuthorizationEnabled && (
          <EditTimesheetAuthorization attendanceSetting={attendanceSetting} />
        )}
        {inconsistenciesEnabled && <MissingClockIn attendanceSetting={attendanceSetting} />}
        <MissingClockOut attendanceSetting={attendanceSetting} />
        {hasAutofillTimesheet && <AutofillTimesheet attendanceSetting={attendanceSetting} />}
      </Box>
    </Section>
  )
}

export default observer(Timesheet)
